import React from 'react';
import { Card } from '../../design-system';
import { FaRegTrashAlt, FaEdit } from 'react-icons/fa';
import { Table, TableCardHeader } from '../../components/Table';
import ButtonCellColumn from '../../components/ButtonCellColumn';

interface ContactEmailsProps {
  emails: any[];
  canEdit: boolean;
  toggleModal: () => void;
  setModalType: (value: any) => void;
  toggleEditModal: () => void;
  handleDeleteDetailsHandler: (value: any) => void;
}

const ContactEmails = ({
  emails,
  canEdit,
  toggleModal,
  setModalType,
  toggleEditModal,
  handleDeleteDetailsHandler,
}: ContactEmailsProps) => {
  const CONTACT_EMAIL_COLUMNS = [
    {
      Header: 'Email',
      accessor: 'value',
    },
    {
      Header: 'Type',
      accessor: 'type',
    },
    {
      Header: 'Created At',
      accessor: 'created_at',
    },
    {
      Header: 'Update At',
      accessor: 'updated_at',
    },
    ...(canEdit
      ? [
          {
            Header: 'Edit',
            disableSortBy: true,
            Cell: ({
              row: {
                original: { id, toggleEditEmailModal },
              },
            }) => (
              <ButtonCellColumn
                onClick={() => toggleEditEmailModal(id)}
                leftIcon={FaEdit}
              />
            ),
          },
          {
            Header: 'Delete',
            accessor: 'handleDeleteDetailsHandler',
            disableSortBy: true,
            Cell: ({
              row: {
                original: { id },
              },
            }) => (
              <ButtonCellColumn
                onClick={() =>
                  handleDeleteDetailsHandler({ id, type: 'email' })
                }
                leftIcon={FaRegTrashAlt}
              />
            ),
          },
        ]
      : []),
  ];

  const toggleNewModal = () => {
    setModalType({ info_type: 'email' });
    toggleModal();
  };

  const toggleEditEmailModal = (id: any) => {
    const email = emails.find((e) => e.id === id);
    setModalType({ ...email, info_type: 'email' });
    toggleEditModal();
  };

  return (
    <Card mt={20}>
      {canEdit ? (
        <TableCardHeader
          name="Emails"
          action="Add Email"
          onClick={toggleNewModal}
        />
      ) : (
        <TableCardHeader name="Emails" disabled />
      )}
      <Table
        name="Emails"
        columns={CONTACT_EMAIL_COLUMNS}
        data={emails.map((item) => ({
          ...item,
          toggleEditEmailModal,
          handleDeleteDetailsHandler,
        }))}
      />
    </Card>
  );
};

export default ContactEmails;
